import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ProfileSPA from './ProfileSPA';

const ProfileSPAWrapper = (props) => (
  <Router basename='/'>
    <ProfileSPA {...props} />
  </Router>
);

export default ProfileSPAWrapper;
